import {decrypt} from '../crypt/decrypt.function';
import {EncryptType} from '../crypt/EncryptType.enum';
import {VARIABLES_ENCRYPT_KEY} from './constants';
import {Variables} from './Variables.interface';

export function decryptVariables(encryptedStr: string): Variables {
  return JSON.parse(
    decrypt({
      s: encryptedStr,
      k: VARIABLES_ENCRYPT_KEY,
      t: EncryptType.Variables,
    })
  );
}
